import { render, staticRenderFns } from "./AddTableForm.vue?vue&type=template&id=34ac7544&"
import script from "./AddTableForm.vue?vue&type=script&lang=js&"
export * from "./AddTableForm.vue?vue&type=script&lang=js&"
import style0 from "./AddTableForm.vue?vue&type=style&index=0&id=34ac7544&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports